import type { RedirectRequest } from "@azure/msal-browser";
import { loginRequest } from "./msalConfig";

export const FORCE_ACCOUNT_PICKER_KEY = "entra_force_account_picker";
const TENANT_ERROR_RETRY_KEY = "entra_tenant_error_retried";

function getErrorMessage(error: unknown): string {
  if (!error || typeof error !== "object") {
    return String(error ?? "");
  }

  const record = error as Record<string, unknown>;
  return [record.errorMessage, record.message, record.errorDescription]
    .filter((value): value is string => typeof value === "string")
    .join(" ");
}

/** True when Entra rejected the signed-in account for this tenant/app. */
export function isWrongTenantError(error: unknown): boolean {
  const message = getErrorMessage(error);
  return (
    message.includes("AADSTS50020") ||
    message.includes("does not exist in tenant") ||
    message.includes("cannot access the application")
  );
}

export function markForceAccountPicker(): void {
  sessionStorage.setItem(FORCE_ACCOUNT_PICKER_KEY, "true");
}

export function shouldForceAccountPicker(): boolean {
  return sessionStorage.getItem(FORCE_ACCOUNT_PICKER_KEY) === "true";
}

export function clearLoginRetryState(): void {
  sessionStorage.removeItem(FORCE_ACCOUNT_PICKER_KEY);
  sessionStorage.removeItem(TENANT_ERROR_RETRY_KEY);
}

export function hasRetriedTenantError(): boolean {
  return sessionStorage.getItem(TENANT_ERROR_RETRY_KEY) === "true";
}

export function markTenantErrorRetried(): void {
  sessionStorage.setItem(TENANT_ERROR_RETRY_KEY, "true");
}

export function buildLoginRequest(options?: {
  forceAccountPicker?: boolean;
}): RedirectRequest {
  const forceAccountPicker =
    options?.forceAccountPicker ?? shouldForceAccountPicker();
  if (forceAccountPicker) {
    return { ...loginRequest, prompt: "select_account" };
  }
  return loginRequest;
}
